import React, { FC, memo } from 'react';
import styled from '@emotion/styled';
import { useHistory } from 'react-router-dom';
import { useI18n, useSelector, useStaffCan } from '~Hooks';
import { Box, Button } from '~Styles';
import Icon from '~ComponentsImproved/Icon';
import Heading from '~ComponentsImproved/Typography/Heading';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import ErrorCircleIcon from '~Assets/icons/error-circle.svg';

/** Styled like the license notice in Handy's printer settings */
const Wrapper = styled(Box)`
  width: 100%;
  max-width: 320px;
  margin: auto;
  padding: 48px 16px;
  box-sizing: border-box;
`;

interface Props {
  /** Handheld already sits inside the Handy shell, so only tablets get a way out */
  isHandy: boolean;
}

/** Shown in Settings when the logged in staff lacks the SETTINGS permission */
const NoAccess: FC<Props> = ({ isHandy }) => {
  const { i18n } = useI18n();
  const history = useHistory();
  const staffCan = useStaffCan();
  const venueId = useSelector((state) => state.venueId);

  return (
    <Wrapper>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        gap="xs"
        justifyContent="center">
        <Icon height="48px" width="48px" src={ErrorCircleIcon} color="var(--colorBlueGray200)" />
        <Heading level={2} color="var(--colorWhite)">
          {i18n('Settings.NoPermission')}
        </Heading>
        <Paragraph style={{ textAlign: 'center' }} level={4} color="var(--colorBlueGray200)">
          {i18n('Settings.NoPermission.Text')}
        </Paragraph>

        {!isHandy && (
          <Box marginTop="large">
            {staffCan.openMainMenu ? (
              <Button onClick={() => history.push(`/venue/${venueId}/gateway`)}>
                {i18n('Settings.NoAccess.GoToGateway')}
              </Button>
            ) : (
              <Button onClick={() => history.push(`/venue/${venueId}/pos`)}>
                {i18n('Settings.NoAccess.GoToPos')}
              </Button>
            )}
          </Box>
        )}
      </Box>
    </Wrapper>
  );
};

export default memo(NoAccess);
